import i18nCalculator from '../calculator.18n';

const template = {
  ...i18nCalculator,
};

export default template;
